export default __webpack_public_path__ + "static/media/Indyvideo.6913c394.mp4";